module.exports = __webpack_public_path__ + "img/11.2cf0905b.png";